<div class="segment-history-panel">
  <nz-table
    #segmentTable
    [nzData]="filteredRows"
    [nzNoResult]="noDataTemplate"
    [nzFrontPagination]="false"
    [nzScroll]="{ x: '79.5rem', y: 'calc(100vh - 18rem)' }"
    nzSize="middle"
    nzBordered
    [nzShowPagination]="false"
  >
    <thead>
      <tr>
        <ng-container *ngFor="let header of headers; trackBy: trackByHeader">
          <th
            *ngIf="header.sortFn; else nonSortableHeader"
            [nzSortFn]="header.sortFn"
            [nzSortDirections]="header.sortDirections"
            [nzSortOrder]="header.sortOrder"
            [nzFilters]="header.filters"
            [nzFilterMultiple]="header.filterMultiple"
            [nzFilterFn]="header.filterFn"
            [nzWidth]="header.width"
            [nzRight]="header.right"
            [class.action-header]="header.name === 'Action'"
          >
            {{ header.name }}
          </th>
          <ng-template #nonSortableHeader>
            <th [nzWidth]="header.width" [nzRight]="header.right" [class.action-header]="header.name === 'Action'">
              {{ header.name }}
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of segmentTable.data">
        <td nzEllipsis [nz-tooltip]="row.queryId">{{ row.queryId }}</td>
        <td nzEllipsis [nz-tooltip]="row.segmentName">{{ row.segmentName }}</td>
        <td nzEllipsis [nz-tooltip]="row.segmentDescription">{{ row.segmentDescription }}</td>
        <td>
          <nz-tag [nzColor]="getStatusColor(row.status)">
            {{ getDisplayStatus(row.status) }}
          </nz-tag>
        </td>
        <td>{{ row.segmentedFans }}</td>
        <td>{{ row.createdOn | dateTime }}</td>
        <td nzEllipsis [nz-tooltip]="row.createdBy">{{ row.createdBy }}</td>
        <td nzRight class="action-column">
          <div class="action-btns">
            <button
              nz-button
              nzType="text"
              aria-label="Edit segment"
              [disabled]="isEditDisabled(row)"
              (click)="onEditClick(row)"
            >
              <span nz-icon nzType="edit" nzTheme="outline"></span>
            </button>
            <button nz-button nzType="text" aria-label="View segment" (click)="openViewSegmentModal(row)">
              <span nz-icon nzType="eye" nzTheme="outline"></span>
            </button>
            <button nz-button nzType="text" aria-label="Delete segment" (click)="delete(row)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <app-segment-view-modal
    [isVisible]="isViewModalVisible"
    [isLoading]="isViewModalLoading"
    [row]="selectedRow"
    [queryRecord]="selectedQueryRecord"
    [queryText]="selectedQueryText"
    (close)="closeViewSegmentModal()"
  ></app-segment-view-modal>

  <ng-template #noDataTemplate>No data available</ng-template>
</div>
